import type { FC } from 'react';

import { useToastSlice } from '../../store/slices/toast/selectors';

import { ToastConnected } from './ToastConnected';

import style from './ToastContainerConnected.module.css';

export const ToastContainerConnected: FC = () => {
  const toasts = useToastSlice.getToasts();

  return (
    <div className={style.toastContainerConnected}>
      {toasts.map((toast) => (
        <ToastConnected {...toast} key={toast.timeStamp} />
      ))}
    </div>
  );
};
